import React, { ReactNode, useMemo } from "react";
import Footer from "../../../components/footer/footer";
import Header from "../../../components/header/header";
import { SpacingBox } from "../../../components/layout/spacing-box";
import { appPagesMapping } from "../../../constants/datalayer";
import {
    ROUTE_APP_CARD_PAYMENT_CONFIRMATION,
    ROUTE_APP_EMPTY,
} from "../../../constants/routes/app";
import { useChannel } from "../../../libs/channels/hooks/use-channel";
import { useDatalayerInit } from "../../../libs/datalayer/hooks/use-datalayer-init";
import { useDatalayerVirtualPage } from "../../../libs/datalayer/hooks/use-datalayer-virtual-page";
import { Wizard } from "./wizard";

type Props = { children?: ReactNode };

export const RoutesContainer: React.FC<Props> = (props: Props) => {
    const { normalizedPathname } = useChannel();
    const paddingTop = useMemo(
        () => (normalizedPathname === ROUTE_APP_EMPTY ? 0 : 14),
        [normalizedPathname]
    );
    const paddingBottom = useMemo(
        () =>
            normalizedPathname === ROUTE_APP_CARD_PAYMENT_CONFIRMATION ? 0 : 40,
        [normalizedPathname]
    );
    useDatalayerInit();
    useDatalayerVirtualPage(appPagesMapping);
    return (
        <div className="router-container" data-testid="router-container">
            <Header />
            <Wizard />
            <SpacingBox pt={paddingTop} pb={paddingBottom}>
                {props.children}
            </SpacingBox>
            <Footer />
        </div>
    );
};
